// extracted by mini-css-extract-plugin
module.exports = {"spin":"CreateStudentAttachmentForm_spin__1mhSF"};